module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/feedback-8e811947c667afa0000f4cd734730a1b.svg";